import Route from '@ember/routing/route';
import { service } from '@ember/service';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import Store from '@ember-data/store';
import { sortByProperties } from 'donor-elf-web/lib/array-utils';
import PledgeModel from 'donor-elf-web/models/pledge';
import { queryWithPages } from 'donor-elf-web/lib/store-utils';
import { PledgeRow } from 'donor-elf-web/components/pledges-table';
import moment from 'moment';

class PledgeFulfillmentModel {
  constructor(pledges: PledgeModel[]) {
    this.hasPledges = pledges.length > 0;

    let ninetyDaysAgo = moment().subtract(90, 'days');
    let sixtyDaysAgo = moment().subtract(60, 'days');
    let thirtyDaysAgo = moment().subtract(30, 'days');
    let today = moment();

    pledges.forEach((pledge) => {
      let nextExpectedDonationDate = pledge.nextExpectedDonationDate;
      if (pledge.endDate && pledge.endDate < today) {
        this.ended.push(new PledgeRow(pledge));
      } else if (pledge.lastDonationDate == null) {
        this.noGifts.push(new PledgeRow(pledge));
      } else if (nextExpectedDonationDate == null) {
        this.current.push(new PledgeRow(pledge));
      } else if (nextExpectedDonationDate < ninetyDaysAgo) {
        this.ninetyDays.push(new PledgeRow(pledge));
      } else if (nextExpectedDonationDate < sixtyDaysAgo) {
        this.sixtyDays.push(new PledgeRow(pledge));
      } else if (nextExpectedDonationDate < thirtyDaysAgo) {
        this.thirtyDays.push(new PledgeRow(pledge));
      } else {
        this.current.push(new PledgeRow(pledge));
      }
    });
    this.ended = sortByProperties(this.ended, ['endDate:desc']);
  }

  noGifts: PledgeRow[] = [];
  ninetyDays: PledgeRow[] = [];
  sixtyDays: PledgeRow[] = [];
  thirtyDays: PledgeRow[] = [];
  current: PledgeRow[] = [];
  ended: PledgeRow[] = [];
  hasPledges: boolean;
}

export default class PledgeFullfilmentRoute extends Route {
  @service declare navbarSettings: NavbarSettingsService;
  @service declare store: Store;

  beforeModel() {
    this.navbarSettings.title = 'Pledge Fulfillment';
  }

  async model() {
    let pledges = await queryWithPages<PledgeModel>({
      store: this.store,
      modelName: 'pledge',
      pageSize: 100,
    });
    return new PledgeFulfillmentModel(pledges);
  }
}
